// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1aoub","name":"ConsentHeader_name__TflSZ","birthday":"ConsentHeader_birthday__37URW","skeleton":"ConsentHeader_skeleton__1TXQc"};